/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import QueryString from 'qs';
import { CAMPAIGN_PROPS } from './app/helpers/tracking/session/sessionTrackingHelpers';

const setDataWithTTL = (key, value, ttlMinutes = 0) => {
    const now = new Date().getTime();
    const expires = now + ttlMinutes * 60000; // Convert minutes to milliseconds

    const item = {
        value,
        expires,
    };
    window.localStorage.setItem(key, JSON.stringify(item));
};

export const getSetDataWithTTL = (key, defaultValue, ttlMinutes = 0) => {
    if (!defaultValue) {
        return null;
    }
    if (ttlMinutes <= 0) {
        return defaultValue;
    }
    const urlParams = window.location.search ? QueryString.parse((window.location.search || '').replace('?', '')) : {};
    const isNewCampaign = Object.keys(CAMPAIGN_PROPS).some((item) => urlParams[item]);

    if (isNewCampaign) {
        setDataWithTTL(key, defaultValue, ttlMinutes);
        return defaultValue;
    }
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) {
        // If data is not set, then set it
        if (defaultValue !== null) {
            setDataWithTTL(key, defaultValue, ttlMinutes);
            return defaultValue;
        }
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    if (now > item.expires) {
        window.localStorage.removeItem(key);
        return null;
    }

    return item.value;
};

export default {};
